import { useEffect, useState } from "react";
import api from "../../api";
import toast from "../../utils/toast";
import "../UserManager.css";

const BASE = "/api/insumos";

export default function ProveedoresManager() {
  const [list, setList] = useState([]);
  const [nuevo, setNuevo] = useState({
    nombre: "",
    rut: "",
    telefono: "",
    direccion: "",
    email: "",
    observaciones: "",
  });
  const [editando, setEditando] = useState(null);
  const [err, setErr] = useState("");

  const cargar = async () => {
    try {
      setErr("");
      const { data } = await api.get(`${BASE}/proveedores`);
      setList(Array.isArray(data) ? data : []);
    } catch (e) {
      setErr(e?.response?.data?.error || e.message);
    }
  };

  useEffect(() => {
    cargar();
  }, []);

  const agregar = async () => {
    if (!nuevo.nombre.trim()) return toast("Nombre es obligatorio");
    try {
      await api.post(`${BASE}/proveedores`, nuevo);
      setNuevo({ nombre: "", rut: "", telefono: "", direccion: "", email: "", observaciones: "" });
      cargar();
    } catch (e) {
      toast(e?.response?.data?.error || "Error al agregar");
    }
  };

  const guardarEdicion = async () => {
    if (!editando?.nombre?.trim()) return;
    try {
      await api.put(`${BASE}/proveedores/${editando.id}`, editando);
      setEditando(null);
      cargar();
    } catch (e) {
      toast(e?.response?.data?.error || "Error al actualizar");
    }
  };

  const eliminar = async (item) => {
    if (!window.confirm(`¿Eliminar proveedor "${item.nombre}"?`)) return;
    try {
      await api.delete(`${BASE}/proveedores/${item.id}`);
      setEditando(null);
      cargar();
    } catch (e) {
      toast(e?.response?.data?.error || "No se pudo eliminar");
    }
  };

  const empty = { nombre: "", rut: "", telefono: "", direccion: "", email: "", observaciones: "" };

  return (
    <div className="um-wrapper">
      <div className="um-card">
        <div className="um-header">
          <h2>Proveedores</h2>
          <span className="um-badge">{list.length} proveedores</span>
        </div>
        <div className="um-form" style={{ gridTemplateColumns: "1fr 1fr 1fr auto" }}>
          <div className="um-field">
            <label>Nombre</label>
            <input placeholder="Nombre del proveedor" value={nuevo.nombre} onChange={(e) => setNuevo({ ...nuevo, nombre: e.target.value })} />
          </div>
          <div className="um-field">
            <label>RUT</label>
            <input placeholder="12.345.678-9" value={nuevo.rut} onChange={(e) => setNuevo({ ...nuevo, rut: e.target.value })} />
          </div>
          <div className="um-field">
            <label>Teléfono</label>
            <input placeholder="912345678" value={nuevo.telefono} onChange={(e) => setNuevo({ ...nuevo, telefono: e.target.value })} />
          </div>
          <div className="um-actions">
            <button className="um-btn um-btn-primary" onClick={agregar}>Agregar</button>
          </div>
          <div className="um-field" style={{ gridColumn: "1 / -1" }}>
            <label>Dirección</label>
            <input placeholder="Dirección" value={nuevo.direccion} onChange={(e) => setNuevo({ ...nuevo, direccion: e.target.value })} />
          </div>
          <div className="um-field">
            <label>Email</label>
            <input type="email" placeholder="email@ejemplo.com" value={nuevo.email} onChange={(e) => setNuevo({ ...nuevo, email: e.target.value })} />
          </div>
          <div className="um-field">
            <label>Observaciones</label>
            <input placeholder="Observaciones" value={nuevo.observaciones} onChange={(e) => setNuevo({ ...nuevo, observaciones: e.target.value })} />
          </div>
        </div>
        {err && <div className="um-error">Error: {err}</div>}
        <div className="um-table-wrap">
          <table className="um-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>RUT</th>
                <th>Teléfono</th>
                <th>Email</th>
                <th className="um-col-actions">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item) => (
                <tr key={item.id}>
                  {editando?.id === item.id ? (
                    <>
                      <td><input value={editando.nombre} onChange={(e) => setEditando({ ...editando, nombre: e.target.value })} /></td>
                      <td><input value={editando.rut} onChange={(e) => setEditando({ ...editando, rut: e.target.value })} /></td>
                      <td><input value={editando.telefono} onChange={(e) => setEditando({ ...editando, telefono: e.target.value })} /></td>
                      <td><input value={editando.email} onChange={(e) => setEditando({ ...editando, email: e.target.value })} /></td>
                      <td className="um-col-actions">
                        <button className="um-btn um-btn-ghost" onClick={guardarEdicion}>Guardar</button>
                        <button className="um-btn um-btn-ghost" onClick={() => setEditando(null)}>Cancelar</button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{item.nombre}</td>
                      <td>{item.rut || "—"}</td>
                      <td>{item.telefono || "—"}</td>
                      <td>{item.email || "—"}</td>
                      <td className="um-col-actions">
                        <button className="um-btn um-btn-ghost" onClick={() => setEditando({ ...item })}>Editar</button>
                        <button className="um-btn um-btn-danger" onClick={() => eliminar(item)}>Eliminar</button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
              {list.length === 0 && (
                <tr><td colSpan={5} className="um-empty">No hay proveedores.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
